import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import featurelist from "../../Components/BodyComponents/featuredProducts/Featurelist";
import axios from "axios";
import { useParams } from "react-router-dom";
import Skeletoncard from "../../Components/BodyComponents/skeletoncard/skeletoncard";
import { Pagination } from "@mui/material";
// import Pagination from "../../Components/Pagination";
import { useSnackbar } from "notistack";
import { addToCart } from "../../Services/Action/Action";
import { addToWishlist } from "../../Services/Action/WishlistAction";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ProductCard from "../../Components/card/ProductCard";

const FilterPage = () => {
  const params = useParams();
  const location = useLocation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const [highLow, setHighLow] = useState("");
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [oldNew, setOldNew] = useState("");

  const handler = (e, get) => {
    dispatch(addToCart(get));
    enqueueSnackbar("Item added to cart", {
      variant: "success",
    });
  };
  const handlerWish = (e, get) => {
    e.preventDefault();
    dispatch(addToWishlist(get));
    enqueueSnackbar("Item added to wishlist", {
      variant: "success",
    });
    console.log(get.price);
  };
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  const handlePage = (e, value) => {
    e.preventDefault();
    setPage(value);
  };
  // console.log(page, "page");
  const [categoriescontent, setCategoriescontent] = useState([]);
  const [filterData, setFilterData] = useState([]);

  useEffect(() => {
    setFilterData(categoriescontent);
  }, [categoriescontent]);

  useEffect(() => {
    setLoading(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/product/filter`,
      params: {
        name: location.state.keyword,
      },
    })
      .then((res) => {
        console.log("paginated", res.data);
        // setPagination(res.data.data.products);
        let response = res.data;
        setCategoriescontent(response);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "error message");
        setLoading(false);
      });
  }, [params.slug, page, location.state.keyword]);

  const filterHandler = async (e) => {
    e.preventDefault();

    setLoading(true);
    await axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/product/filter`,
      params: {
        price_filter: highLow,
        sort_filter: oldNew,
        min_price: min,
        max_price: max,
        name: location.state.keyword,
      },
    })
      .then((res) => {
        console.log("clicked filter Data", res.data);
        setFilterData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    setLoading(false);
  };

  return (
    <div className="categories-content-main">
      <div className="container">
        <div className="categories-content-bar clearfix">
          <div className="left-bar">
            <div className="row">
              <div className="col-lg-2 col-md-6">
                <p>{categoriescontent.length} items</p>
              </div>

              <div className=" col-lg-3 col-md-6 form-control-sort">
                <label>Sort by :</label>
                <select
                  className="categories-content-select"
                  onChange={(e) => setOldNew(e.target.value)}
                >
                  <option value="">Choose</option>
                  <option value="oldest">Oldest</option>
                  <option value="newest">Newest</option>
                </select>
              </div>

              {/* <li>
                <label>Max Price :</label>
                <input
                  className="form-control-price"
                  onChange={(e) => setMax(e.target.value)}
                />
              </li> */}
              <div className="col-lg-2 col-md-6">
                <label>Min Price :</label>
                <input
                  className="form-control-price"
                  onChange={(e) => setMin(e.target.value)}
                />
              </div>
              <div className="col-lg-2 col-md-6">
                <label>Max Price :</label>
                <input
                  className="form-control-price"
                  onChange={(e) => setMax(e.target.value)}
                />
              </div>

              <div className="col-lg-2 col-md-6">
                <label>Order:</label>
                <select
                  className="categories-content-select"
                  onChange={(e) => setHighLow(e.target.value)}
                >
                  <option value="">Choose</option>
                  <option value="high_to_low">High To Low</option>
                  <option value="low_to_high">Low To High</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="filter-btn">
          <button onClick={filterHandler}>Filter</button>
        </div>
        <div className="categories-content-body">
          <div className="row">
            {filterData.length > 0 || loading ? (
              <>
                {loading ? (
                  <>
                    <Skeletoncard />
                  </>
                ) : (
                  filterData.map((get, id) => {
                    return (
                      <div className="col-md-3" key={id}>
                        <ProductCard data={get} />
                        {/* <div className="cart-main">
                          <div className="feature-img">
                            <NavLink to={`/${get.category_slug}/${get.slug}`}>
                              <img
                                src={get?.image}
                                alt="featureproducts"
                                className="img-fluid"
                              />
                            </NavLink>
                            <p onClick={(e) => handler(e, get)}>
                              {" "}
                              <i class="fas fa-shopping-cart"></i>
                            </p>
                          </div>
                          <div>
                            <p className="cart-content-icon">{get?.icon}</p>
                            <p className="cart-content-name">{get?.name}</p>
                            <p className="cart-content-price">${get?.price}</p>
                          </div>
                        </div> */}
                      </div>
                    );
                  })
                )}
              </>
            ) : (
              <h5 className="no-items mb-5">No items to show</h5>
            )}
          </div>
        </div>
        {/* 
        <div className="pagination-main mt-3">
          <Pagination
            totalRecords={pagination.total}
            pageLimit={pagination?.per_page}
            pageNeighbours={10}
          />
        </div> */}

        {loading === false && filterData.length > 0 && pagination.total ? (
          <>
            <div className="pagination-main">
              <Pagination
                shape="rounded"
                count={pagination?.total}
                page={page}
                onChange={handlePage}
                color="primary"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default FilterPage;
